<div class="header-cell">
	<div matSuffix class="filter-suffix">
		@if (column.sortDisabled === false) {
			<span
				class="header-text sort-icon"
				mat-sort-header
				[title]="column.tooltip ? column.tooltip : column.headerText"
				(click)="$event.stopPropagation(); $event.preventDefault()">
				{{ column.headerText }}
			</span>
		} @else {
			<span class="header-text" [title]="column.tooltip ? column.tooltip : column.headerText" (click)="$event.stopPropagation(); $event.preventDefault()">
				{{ column.headerText }}
			</span>
		}
	</div>
</div>
